import {Component, Inject, OnInit} from '@angular/core';
import {Service, ServiceAdministrationService} from '@gt-api';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {catchError, tap} from 'rxjs/operators';
import {EMPTY} from 'rxjs';
import {checkResponse} from '@app/shared/utils/app-utils';
import {ServiceTemplateId} from '@app/models/enums/service-template-id.enum';
import {GtPhoneNumberUtil} from '@app/shared/utils/gt-phone-number.util';
import {GtNotificationService} from '@app/services/gt-notification.service';

export interface ServiceNumberDialogData {
  service: Service;
  editMode: boolean;
}

@Component({
  selector: 'gt-service-number-editor',
  templateUrl: './service-number-editor.component.html',
  styleUrls: ['./service-number-editor.component.scss']
})
export class ServiceNumberEditorComponent implements OnInit {
  service: Service;
  editMode = false;

  supportedPatterns = [ServiceTemplateId.MainNumber, ServiceTemplateId.AnswerGroup];

  constructor(
    private dialogRef: MatDialogRef<ServiceNumberEditorComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: ServiceNumberDialogData,
    private serviceAdministrationService: ServiceAdministrationService,
    private notificationService: GtNotificationService
  ) {}

  ngOnInit(): void {
    if (this.dialogData) {
      this.service = this.dialogData.service;
      this.editMode = this.dialogData.editMode;
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick() {
    if (this.editMode) {
      this.serviceAdministrationService
        .editServiceName1(this.service.number, this.service.organization, this.service.name)
        .pipe(
          checkResponse(),
          tap(() => this.dialogRef.close(true)),
          catchError(error => {
            this.notificationService.showErrorCustomMessage(error);
            console.error('failed to edit service', error);
            return EMPTY;
          })
        )
        .subscribe();
    } else {
      let create$;
      if (this.service.number) {
        create$ = this.serviceAdministrationService.createService2(
          GtPhoneNumberUtil.toBackend(this.service.number),
          this.service.pattern,
          this.service.organization,
          this.service.name
        );
      } else {
        create$ = this.serviceAdministrationService.createService1(this.service.pattern, this.service.organization, this.service.name);
      }
      create$
        .pipe(
          checkResponse(),
          tap(() => this.dialogRef.close(true)),
          catchError(error => {
            this.notificationService.showErrorCustomMessage(error);
            console.error('failed to create service', error);
            return EMPTY;
          })
        )
        .subscribe();
    }
  }
}
